import React, { Component } from 'react'

/* Components */
import TopBarView from './TopBarView'

/* Modules */
// import * as firebase from 'firebase'
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

/* Modules */
import { Redirect } from 'react-router-dom';

class TopBar extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userIsLogged: true,
            userType: ''
        }
    }

    componentWillMount = () => {
        // Check if user is logged In
        const auth = getAuth();
        onAuthStateChanged(auth, user => {
            if (!user) {
                this.setState({
                    userIsLogged: false
                })
            } else {
                // firebase.firestore().collection('users').get()
                // .then(users => {
                //     users.forEach(childUser => {
                //         if(childUser.data().email === user.email)
                //             this.setState({ userType: childUser.data().type })
                //     })
                // })
            }
        })
    }

    logout = () => {
        const auth = getAuth();
        signOut(auth);
    }

    render() {
        if (!this.state.userIsLogged) {
            return <Redirect to={'/'} />
        }

        return (
            <TopBarView
                logout={() => this.logout()}
            />
        )
    }
}

export default TopBar